import { render, staticRenderFns } from "./InstitucionesView.vue?vue&type=template&id=81143d46&"
import script from "./InstitucionesView.vue?vue&type=script&lang=js&"
export * from "./InstitucionesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports